module.exports = __webpack_public_path__ + "static/banner-image-earch-942c2b93cfc17c7c3fb51313d9cec369.gif";